export function classNameBlocking(value) {
    switch (value) {
        case "Blocage client":
            return "block-client"

        case "MYPacome":
            return "block-pm"

        case "Airbnb":
            return "block-airbnb"

        case "HomeAway":
            return "block-ha"

        case "Booking":
            return "block-booking"

        case "Blocage propriétaire":
            return "block-back"

        case "unavailable":
            return "block-unavailable"
        case "Rent-Client":
            return "block-client"
        case "Gites de France":
            return "block-gites"

        default:
            return ""
    }
}

/** OTA availability markers. Same rule as PM-2 — hide these from owners. */
export function isUnavailableBookingDescription(description) {
    if (!description || typeof description !== 'string') return false
    const d = description.trim().toLowerCase()
    return (
        (d.includes('closed') && d.includes('not available')) ||
        d.includes('airbnb (not available)') ||
        d === 'not available'
    )
}

export function shouldHideBooking(booking) {
    return isUnavailableBookingDescription(booking?.description)
}

export function titleName(value, description) {
    if (value == null || typeof value !== 'string') {
        return value || '';
    }
    const trimmed = value.trim();
    const lower = trimmed.toLowerCase();
    if (lower === 'rent-client') {
        return 'Blocage client';
    }
    if (lower === 'unavailable' || lower === 'block-unavailable') {
        return "Indisponibilité"
    }
    if (trimmed.startsWith("-//Airbnb Inc")) {
        return "Airbnb"
    } else if (trimmed.startsWith("-//HomeAway.com")) {
        return "HomeAway"
    } else if (trimmed.startsWith("-//admin.booking.com")) {
        return "Booking"
    } else if (trimmed.startsWith("Planning Manager")) {
        return "MYPacome"
    } else if (trimmed.startsWith("ical-gites")) {
        return "Gites de France"
    } else if (trimmed === "back") {
        return "Blocage propriétaire"
    } else if (lower === 'airbnb') {
        return "Airbnb"
    } else if (lower === 'booking') {
        return "Booking"
    } else if (lower === 'homeaway') {
        return "HomeAway"
    } else if (lower === 'gdf') {
        return "Gites de France"
    } else if (lower === 'other' || lower === 'autre') {
        return inferLabelFromDescription(description) || value
    } else {
        return value
    }
}

function inferLabelFromDescription(description) {
    if (!description || typeof description !== 'string') return ''
    const d = description.trim().toLowerCase()
    if (!d) return ''
    if (d === 'reserved' || d.includes('airbnb')) return 'Airbnb'
    if (d.startsWith('closed') || d.includes('booking.com')) return 'Booking'
    if (d.includes('homeaway') || d.includes('abritel') || d.includes('vrbo')) return 'HomeAway'
    if (d.includes('gites')) return 'Gites de France'
    return ''
}